import styled from 'styled-components';
import { motion } from 'framer-motion';
import { GREEN_COLOR } from '../constants';

export const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
`;

export const ModalContent = styled(motion.div)`
  background: white;
  padding: 2.5rem;
  border-radius: 24px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  position: relative;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6b7280;
  padding: 0.5rem;
  line-height: 1;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f3f4f6;
  }
`;

export const ModalTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.5rem;
`;

export const ModalText = styled.p`
  color: #6b7280;
  margin-bottom: 2rem;
  font-size: 1.1rem;
`;

export const QRGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const QRColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const QRContainer = styled.div`
  padding: 1rem;
  background: #f9fafb;
  border-radius: 16px;
  display: inline-block;
`;

export const StoreLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #1f2937;

  img {
    height: 24px;
    width: auto;
  }
`;

export const DirectLink = styled.a`
  display: inline-block;
  background: ${GREEN_COLOR};
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: background-color 0.3s;
  width: 100%;
  box-sizing: border-box;
  text-align: center;

  &:hover {
    background: #2e4a27;
  }
`;
